module.exports = __webpack_public_path__ + "img/I-94.97345fad.svg";